const RELOAD_KEY = "tazej_chunk_reload_at";
const MIN_RELOAD_GAP_MS = 20000;

const CHUNK_ERROR_PATTERNS = [
    "Failed to fetch dynamically imported module",
    "Importing a module script failed",
    "error loading dynamically imported module",
    "Unable to preload CSS",
];

export function isChunkLoadError(error) {
    const msg = String(error?.message || error || "");
    return CHUNK_ERROR_PATTERNS.some((p) => msg.includes(p));
}

/**
 * After a deploy, tabs still holding the previous index.html request hashed
 * chunks that no longer exist. One hard reload picks up the new build.
 * Returns false when a reload already happened recently (or storage is blocked)
 * so a genuinely missing chunk cannot cause a reload loop.
 */
export function reloadOnceForStaleChunk(targetUrl) {
    try {
        const last = Number(window.sessionStorage.getItem(RELOAD_KEY) || 0);
        if (Date.now() - last < MIN_RELOAD_GAP_MS) {
            return false;
        }
        window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    } catch {
        return false;
    }
    if (targetUrl) {
        window.location.assign(targetUrl);
    } else {
        window.location.reload();
    }
    return true;
}

export function initStaleChunkReload(router) {
    if (typeof window === "undefined" || window.__tazejChunkReload) {
        return;
    }
    window.__tazejChunkReload = true;

    window.addEventListener("vite:preloadError", (event) => {
        if (reloadOnceForStaleChunk()) {
            event.preventDefault();
        }
    });

    router?.onError((error, to) => {
        if (isChunkLoadError(error)) {
            reloadOnceForStaleChunk(to?.fullPath);
        }
    });
}
